<template>
  <div class="faq-wrap style1 pb-100">
    <div class="container">
      <div class="row gx-5">
        <div
          class="col-lg-6"
          data-aos="fade-right"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          <div class="faq-bg-two bg-f"></div>
        </div>

        <div
          class="col-lg-6"
          data-aos="fade-left"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          <div class="faq-content">
            <div class="content-title style1">
              <span>People Also Ask</span>
              <h2>
                Frequently Asked Questions About The Patient For The Public
              </h2>
            </div>

            <div class="accordion" id="accordionExample_one">
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingOne">
                  <button
                    class="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    <span>
                      <i class="ri-add-line plus"></i>
                      <i class="ri-subtract-line minus"></i>
                    </span>
                    What medical expenses are not tax deductible?
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  class="accordion-collapse collapse show"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample_one"
                >
                  <div class="accordion-body">
                    <div class="single-product-text">
                      <p>
                        It is a long established fact that a reader will be
                        distracted by the read content of page when looking at
                        its layout. The point of using Lorem Ipsum is that it
                        has a more-or-less no content here making it look like.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="accordion-item">
                <h2 class="accordion-header" id="headingTwo">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    <span>
                      <i class="ri-add-line plus"></i>
                      <i class="ri-subtract-line minus"></i>
                    </span>
                    Are dental expenses deductible 2022?
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample_one"
                >
                  <div class="accordion-body">
                    <p>
                      It is a long established fact that a reader will be
                      distracted by the read content of page when looking at its
                      layout. The point of using Lorem Ipsum is that it has a
                      more-or-less no content here making it look like.
                    </p>
                  </div>
                </div>
              </div>

              <div class="accordion-item">
                <h2 class="accordion-header" id="headingThree">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    <span>
                      <i class="ri-add-line plus"></i>
                      <i class="ri-subtract-line minus"></i>
                    </span>
                    What is the standard deduction for 2022 for over 65?
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample_one"
                >
                  <div class="accordion-body">
                    <p>
                      It is a long established fact that a reader will be
                      distracted by the read content of page when looking at its
                      layout. The point of using Lorem Ipsum is that it has a
                      more-or-less no content here making it look like.
                    </p>
                  </div>
                </div>
              </div>

              <div class="accordion-item">
                <h2 class="accordion-header" id="headingFour">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                  >
                    <span>
                      <i class="ri-add-line plus"></i>
                      <i class="ri-subtract-line minus"></i>
                    </span>
                    What qualifies as a qualified medical expense?
                  </button>
                </h2>
                <div
                  id="collapseFour"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingFour"
                  data-bs-parent="#accordionExample_one"
                >
                  <div class="accordion-body">
                    <p>
                      It is a long established fact that a reader will be
                      distracted by the read content of page when looking at its
                      layout. The point of using Lorem Ipsum is that it has a
                      more-or-less no content here making it look like.
                    </p>
                  </div>
                </div>
              </div>

              <div class="accordion-item">
                <h2 class="accordion-header" id="headingFive">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFive"
                    aria-expanded="false"
                    aria-controls="collapseFive"
                  >
                    <span>
                      <i class="ri-add-line plus"></i>
                      <i class="ri-subtract-line minus"></i>
                    </span>
                    How much can you deduct for dental expenses?
                  </button>
                </h2>
                <div
                  id="collapseFive"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingFive"
                  data-bs-parent="#accordionExample_one"
                >
                  <div class="accordion-body">
                    <p>
                      It is a long established fact that a reader will be
                      distracted by the read content of page when looking at its
                      layout. The point of using Lorem Ipsum is that it has a
                      more-or-less no content here making it look like.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PeopleAlsoAsk",
};
</script>